module.exports = ".createPresBtn {\n  float: none; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/devices/editSchedule/editSchedule.component.scss
// module id = ./src/app/views/devices/editSchedule/editSchedule.component.scss
// module chunks = main